import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { shouldInvertText, TOKEN_INVERSE_TEXT, TOKEN_PRIMARY_TEXT } from "../../utils/colors";
import classes from './AgentHeader.module.scss';
const AgentHeader = ({ color, agent, language }) => {
    const { t } = useTranslation();
    const ref = useRef(null);
    return (_jsx("div", Object.assign({ ref: ref, className: classNames(classes.agent, {
            [classes.inverse]: color && shouldInvertText(TOKEN_INVERSE_TEXT, color, TOKEN_PRIMARY_TEXT, ref.current),
        }) }, { children: _jsxs("p", Object.assign({ className: classes.text }, { children: [_jsx("span", Object.assign({ className: classes.with }, { children: agent
                        ? t('You are chatting with', { lng: language })
                        : t('Thank you for contacting us', { lng: language }) }), void 0), _jsx("br", {}, void 0), _jsx("span", Object.assign({ className: classes.name }, { children: agent ? agent.firstName : t('How can I help?', { lng: language }) }), void 0)] }), void 0) }), void 0));
};
export default AgentHeader;
//# sourceMappingURL=AgentHeader.js.map